function setCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      var expires = "expires="+ d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  function getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
              c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
          }
      }
      return "";
  }

  $(document).on("submit",".pf_form",function(e){
    e.preventDefault()
    const input = $(this).find('input')[0]
    console.log("Input",input)
    if(input.value.toLowerCase() === getCookie('store-act-key').toLowerCase()){
      setCookie('store-pass',input.value,3);
      window.location.href = '/';
    }else{
      const span = $(this).find('span')[0]
      console.log("Span",span)
      span.style.display = 'block';
    }
  })